export function RequiredMark() {
  return <span className="text-red-500 ml-0.5">*</span>
}